import {ISpecificDialogsService} from "./specific-dialogs.service.interface";
import {ServiceBase} from "../ServiceBase";
import {DialogButtonClickHandleResultEnum} from "../dialog/dialog.service.interface";

export class SpecificDialogsService extends ServiceBase implements ISpecificDialogsService {
    enforceHybridAppModal(analyticsOnClick?: {
        category: string;
        action?: string;
        label?: string;
        value?: any;
        omitStructuredLogger?: boolean;}
    ) {
        let DownloadAppIcon = this.services.theme.currentTheme.icons.sideMenuDownloadApp;
        return this.services.dialog.showSimpleTextModal({
            title: this.services.translation.translate('ENFORCE_HYBRID_APP_TITLE'),
            text: this.services.translation.translate('ENFORCE_HYBRID_APP_TEXT'),
            iconSvg: DownloadAppIcon,
            buttons: [
                {
                    text: this.services.translation.translate('ENFORCE_HYBRID_APP_CONTINUE_BUTTON'),
                    buttonPreset: 'secondary',
                    onClick: async () => {
                        if (analyticsOnClick) {
                            const {category, action, label, value, omitStructuredLogger} = analyticsOnClick;
                            this.services.analytics.sendAnalytics(category, action, label, value, omitStructuredLogger);
                        }
                        await this.services.externalLinks.openDownloadApp();
                        return DialogButtonClickHandleResultEnum.KeepDialogOpen;
                    }
                }
            ]
        });
    }
}